module.exports = __webpack_public_path__ + "img/1.01cfff50.jpg";